import Product from 'classes/Product';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { combineReducers } from 'redux';

import ProductTypes from './types';

const exportCouponsBatch = (actionName: string, initialState: any, request: String, success: String, error: String) => {
  return (state = initialState ? initialState : {}, action: any) => {
    switch (action.type) {
      case request:
        return { ...state, isExporting: true };
      case success:
        const dateExport = moment(new Date()).format('DD-MM-YYYY');
        let fileExport = new Blob([action.payload], { type: 'text/csv; charset=utf-8' });
        saveAs(fileExport, `cupom-lote-${dateExport}.csv`);
        return { ...state, isExporting: false };
      case error:
        return { ...state, isExporting: false };
      default:
        return state;
    }
  };
};

const currentProduct = (actionName: string, initialState: any, request: String, success: String, error: String) => {
  return (state = initialState ? initialState : {}, action: any) => {
    switch (action.type) {
      case request:
        return { ...state, isFetching: true };
      case success:
        const product = new Product(action.payload.data);
        return { ...product, isFetching: false };
      case error:
        return { ...state, isFetching: false };
      default:
        return state;
    }
  };
};

export const productReducer = combineReducers({
  list: ProductTypes.list.getReducer(),
  listMine: ProductTypes.listMine.getReducer(),
  listVariations: ProductTypes.listVariations.getReducer(),
  coProducers: ProductTypes.coProducers.getReducer(),
  new: ProductTypes.new.getReducer(),
  edit: ProductTypes.edit.getReducer(),
  categories: ProductTypes.categories.getReducer(),
  product: ProductTypes.product.getReducer(),
  productBadges: ProductTypes.productBadges.getReducer(),
  productInvoice: ProductTypes.productInvoice.getReducer(),
  affiliatesProductStatusSummary: ProductTypes.affiliatesProductStatusSummary.getReducer(),
  productStatus: ProductTypes.productStatus.getReducer(),
  productInviteAffiliate: ProductTypes.productInviteAffiliate.getReducer(),
  productDelivery: ProductTypes.productDelivery.getReducer(),
  cloneProductById: ProductTypes.cloneProductById.getReducer(),
  deliveryMethods: ProductTypes.deliveryMethods.getReducer(),
  file: ProductTypes.file.getReducer(),
  newCoproducer: ProductTypes.newCoproducer.getReducer(),
  listProductsChildren: ProductTypes.listProductsChildren.getReducer(),
  productCampaigns: ProductTypes.productCampaigns.getReducer(),
  editProductCampaign: ProductTypes.editProductCampaign.getReducer(),
  createProductCampaign: ProductTypes.createProductCampaign.getReducer(),
  updatePostback: ProductTypes.updatePostback.getReducer(),
  listPostback: ProductTypes.listPostback.getReducer(),
  createProductCampaignTracker: ProductTypes.createProductCampaignTracker.getReducer(),
  loadProductCampaignTracker: ProductTypes.loadProductCampaignTracker.getReducer(),
  verifyDomain: ProductTypes.verifyDomain.getReducer(),
  listCoupons: ProductTypes.listCoupons.getReducer(),
  excludeCoupon: ProductTypes.excludeCoupon.getReducer(),
  createCoupons: ProductTypes.createCoupons.getReducer(),
  listCoProductions: ProductTypes.listCoProductions.getReducer(),
  listIrregularProducts: ProductTypes.listIrregularProducts.getReducer(),
  listAffiliations: ProductTypes.listAffiliations.getReducer(),
  inviteAffiliations: ProductTypes.inviteAffiliations.getReducer(),
  cancelAffilation: ProductTypes.cancelAffilation.getReducer(),
  listRecoveryMessages: ProductTypes.listRecoveryMessages.getReducer(),
  updateRecoveryMessages: ProductTypes.updateRecoveryMessages.getReducer(),
  createRecoveryMessages: ProductTypes.createRecoveryMessages.getReducer(),
  deleteProductCampaignTracker: ProductTypes.deleteProductCampaignTracker.getReducer(),
  listCouponsBatch: ProductTypes.listCouponsBatch.getReducer(),
  exportCouponsBatch: ProductTypes.exportCouponsBatch.createReducer(exportCouponsBatch),
  createCouponsBatch: ProductTypes.createCouponBatch.getReducer(),
  inactivateBatch: ProductTypes.inactivateBatch.getReducer(),
  listProductsCampaignFilter: ProductTypes.listProductsCampaignFilter.getReducer(),
  currentProduct: ProductTypes.currentProduct.createReducer(currentProduct),
  getDeliveryIntegrationActiveList: ProductTypes.getDeliveryIntegrationActiveList.getReducer(),
});
